/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Input,
  Row,
  // Select,
  Modal,
  Table,
  Tooltip,
  Typography,
  Switch,
  Skeleton,
  DatePicker,
  Badge,
  Dropdown,
  Popover,
} from "antd";
import {
  SettingOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  FileExcelOutlined,
  DownOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Prompt, useHistory } from "react-router";
// import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import { purchaseHeaders, items } from "./data";
import useBeforeUnload from "../../components/Prompting";
import { useDispatch, useSelector } from "react-redux";
import {
  // deletePurchaseInvoiceList,
  loadPurchaseInvoice,
  // loadPurchasePrintReceipt,
  loadPurchaseTotal,
  loadTotalPaid,
  loadTotalUnPaid,
} from "../../store/purchase-invoice/actions";
import { BiCalendar, BiRightArrowAlt } from "react-icons/bi";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";
import { loadPrefixSettingsList } from "../../store/expenses/actions";
import api from "../../helpers";

const PurchaseInvoice = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  //state initial
  const [salesTab, setSalesTab] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  // const [selectDays, setSelectDays] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState(false);
  const [toDate, setToDate] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select Options");

  const [search, setSearch] = useState("");

  //organisation id from login response

  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";

  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const salesInvoiceList = { organizationId: organizationId };
  const purchasePrefixList = {
    organizationId: organizationId,
    isType: "isPurchase",
  };
  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTimeout(() => {
        setTableLoading(false);
      }, 1000);
    }, 2000);
    dispatch(loadPurchaseInvoice(salesInvoiceList));
    dispatch(loadPurchaseTotal(salesInvoiceList));
    dispatch(loadTotalPaid(salesInvoiceList));
    dispatch(loadTotalUnPaid(salesInvoiceList));
    dispatch(loadPrefixSettingsList(purchasePrefixList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const {
    purchase_invoice_list = [],
    // purchase_print_receipt = [],
    // purchase_barcode_list = [],
    purchase_total_list = [],
    total_paid_list = [],
    total_unpaid_list = [],
  } = useSelector((state) => state.PurchaseInvoice);
  const { prefix_settings_list = [] } = useSelector((state) => state.Expenses);

  //States data
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [purchaseInvoiceData, setPurchaseInvoiceData] = useState({
    prefix: "",
    seqNo: "",
    purchaseInvoiceNo: "",
    purchaseInvoiceDate: "",
  });

  const handleChange = (e) => {
    setPurchaseInvoiceData({
      ...purchaseInvoiceData,
      [e.target.name]: e.target.value,
    });
  };
  const media = useMedia();
  // const [searchOpen, setSearchOpen] = useState(false);

  //window height/width

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //Custom Fields State values
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);
  const [purchaseRemoveId, setPurchaseRemoveId] = useState("");
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //header columns
  const HeaderData = [
    {
      key: "purchaseinvoiceDate",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      dataIndex: "purchaseinvoiceDate",
      width: 140,
      // fixed: "left",
      sorter: (a, b) =>
        a.purchaseinvoiceDate.length - b.purchaseinvoiceDate.length,
    },
    {
      key: "purchaseinvoiceNo",
      title: (
        <p className="header-purchase-invoice font-semibold">Invoice No</p>
      ),
      dataIndex: "purchaseinvoiceNo",
      width: 140,
    },
    {
      key: "vendorName",
      title: (
        <p className="header-purchase-invoice font-semibold">Vendor Name</p>
      ),
      dataIndex: "vendorName",
      width: 140,
    },
    {
      key: "products",
      title: <p className="header-purchase-invoice font-semibold">Items</p>,
      dataIndex: "products",
      width: 80,
    },
    {
      key: "fullyPaid",
      title: (
        <p className="header-purchase-invoice font-semibold">Fully Paid</p>
      ),
      dataIndex: "fullyPaid",
      width: 110,
    },
    {
      key: "totalAmount",
      title: <p className="header-purchase-invoice font-semibold">Total</p>,
      dataIndex: "totalAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <h1
            className="cursor-pointer ml-1 header-sales-invoice"
            onClick={() => purchaseInvoiceRoutes(text)}
          >
            {text.totalAmount && text.totalAmount.toLocaleString("en-IN")}
          </h1>
        </div>
      ),
      width: 110,
    },
    {
      key: "status",
      title: <p className="header-purchase-invoice font-semibold">Status</p>,
      dataIndex: "status",
      width: 110,
    },
    {
      key: "action",
      title: <p className="header-purchase-invoice font-semibold">Action</p>,
      dataIndex: "action",
      width: 110,
    },
  ];

  const purchaseInvoiceRoutes = (data) => {
    history.push({
      pathname: "/purchase-invoice/data",
      state: {
        purchaseInvoice: data,
        paid: total_paid_list.totalPaidAmount,
        unpaid: total_unpaid_list.totalUnPaidAmount,
      },
    });
  };

  //purchase row
  const [salesInvoiceRows, setSalesInvoiceRows] = useState([
    {
      _id: "",
      key: "",
      amount: "",
      authorizedsignature: "",
      autoroundoff: "",
      autoroundoffamount: "",
      beforeautoroundoffamount: "",
      charge: "",
      createdAt: "",
      createdBy: "",
      financialyearId: "",
      isHistory: "",
      items: "",
      notes: "",
      organizationId: "",
      // amount: "",
      purchaseinvoiceNo: "",
      purchaseinvoiceDate: "",
      partyId: "",
      status: "",
      subtotalamount: "",
      taxableAmonut: "",
      totalAmount: "",
      termsandconditions: "",
      totaltax: "",
      totaltaxableValue: "",
      transActionType: "",
      type: "",
      updatedAt: "",
      vendorAddress: "",
      vendorCity: "",
      vendorId: "",
      vendorName: "",
      products: "",
      fullyPaid: "",
      action: "",
      vendorNameValue: "",
    },
  ]);

  //data table
  const purchaseInvoiceDataTable =
    purchase_invoice_list && purchase_invoice_list.length > 0
      ? purchase_invoice_list.map((data, index) => {
          return {
            _id: data._id,
            key: index + 1,
            amount: (
              <div className="flex">
                <p>{"₹ "}</p>
                <h1
                  className="cursor-pointer ml-1 header-sales-invoice"
                  onClick={() => purchaseInvoiceRoutes(data)}
                >
                  {data.totalAmount.toLocaleString("en-IN")}
                </h1>
              </div>
            ),
            purchaseinvoiceNo: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => purchaseInvoiceRoutes(data)}
              >
                {data.prefixName
                  ? data.prefixName + "" + data.purchaseinvoiceNo
                  : data.purchaseinvoiceNo}
              </h1>
            ),
            purchaseinvoiceDate: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => purchaseInvoiceRoutes(data)}
              >
                {data.purchaseinvoiceDate
                  ? moment(data.purchaseinvoiceDate).format("DD-MM-YYYY")
                  : "--"}
              </h1>
            ),
            authorizedsignature: data.authorizedsignature,
            autoroundoffamount: data.autoroundoffamount,
            autoroundoff: data.autoroundoff,
            beforeautoroundoffamount: data.beforeautoroundoffamount,
            charge: data.charge,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            financialyearId: data.financialyearId,
            isHistory: data.isHistory,
            partyId: data.partyId,
            items: data.items,
            notes: data.notes,
            organizationId: data.organizationId,

            subtotalamount: data.subtotalamount,
            taxableAmonut: data.taxableAmonut,
            termsandconditions: data.termsandconditions,
            totaltax: data.totaltax,
            totalAmount: data.totalAmount,
            totaltaxableValue: data.totaltaxableValue,
            transActionType: data.transActionType,
            type: data.type,
            updatedAt: data.updatedAt,
            vendorAddress: data.vendorAddress,
            vendorCity: data.vendorCity,
            vendorId: data.vendorId,
            productList: data.productList,
            products: data.items.length > 0 ? data.items.length : 0,
            vendorName: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => purchaseInvoiceRoutes(data)}
              >
                {data.vendorName}
              </h1>
            ),
            vendorNameValue: data.vendorName,
            // dueIn: (
            //   <h1
            //     className="cursor-pointer header-sales-invoice"
            //     onClick={() => purchaseInvoiceRoutes(data)}
            //   >
            //     <Badge
            //       className={
            //         data.purchaseinvoiceDate && validTill > 10
            //           ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
            //           : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
            //       }
            //     >
            //       {data.purchaseinvoiceDate && validTill > 1
            //         ? validTill + " Days"
            //         : validTill == 1
            //         ? validTill + " Day"
            //         : validTill <= 0
            //         ? "Expired"
            //         : ""}
            //     </Badge>
            //   </h1>
            // ),
            fullyPaid: (
              <Badge
                className={
                  data.markasfullypaid === true
                    ? "bg-[green] font-semibold header-sales-invoice rounded-md text-[white] text-[11px] pt-1 pb-1 pr-3 pl-3"
                    : "bg-[#eb7367] font-semibold header-sales-invoice rounded-md text-[white] text-[11px] pt-1 pb-1 pr-3 pl-3"
                }
                onClick={() => purchaseInvoiceRoutes(data)}
              >
                {data.markasfullypaid === true ? "YES" : "NO"}
              </Badge>
            ),
            action: (
              <div
                onClick={() => {
                  setDeletePurchaseInvoiceModal(true);
                  setPurchaseRemoveId(data._id);
                }}
              >
                {/* <p className="flex text-[14px] font-semibold"> */}
                <DeleteOutlined className="cursor-pointer mr-2 text-[16px] font-semibold text-[#b31707]" />
                {/* Delete */}
                {/* </p> */}
              </div>
              // <Popover
              //   placement="bottomRight"
              //   trigger={"hover"}
              //   content={actionList}
              // >
              //   <div className="text-[#0c8ce9] cursor-pointer pr-1 pt-1">
              //     <MenuOutlined />
              //   </div>
              // </Popover>
            ),

            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
                onClick={() => purchaseInvoiceRoutes(data)}
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (purchaseInvoiceDataTable && purchaseInvoiceDataTable.length > 0) {
      setSalesInvoiceRows(purchaseInvoiceDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchase_invoice_list]);

  //expand row

  const expandColumns = [
    {
      title: <p className="header-expand-purchase-invoice">Model</p>,
      dataIndex: "modelName",
      key: "modelName",
    },
    {
      title: <p className="header-expand-purchase-invoice">Grade Name</p>,
      dataIndex: "gradeName",
      key: "gradeName",
    },
    {
      title: <p className="header-expand-purchase-invoice">Quantity</p>,
      // title: <p className="header-expand-purchase-invoice">Quantity / IMEI</p>,
      key: "qty",
      dataIndex: "qty",
    },
    {
      title: <p className="header-expand-purchase-invoice">Purchase Price</p>,
      dataIndex: "purchasePrice",
      key: "purchasePrice",
    },
    {
      title: <p className="header-expand-purchase-invoice">Total</p>,
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
  ];

  // expand row
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const onTableRowExpand = (expanded, record) => {
    const keys = [];
    if (expanded) {
      keys.push(record._id); // I have set my record.id as row key. Check the documentation for more details.
    }

    setExpandedRowKeys(keys);
  };
  const expandedRowRender = (row) => {
    const splitData = {
      items: row.items.flatMap((item) =>
        item.serialDetails.map((serial) => ({
          itemId: item.itemId,
          modelName: item.modelName,
          brandName: item.brandName,
          gradeName: item.gradeName,
          purchasePrice: item.purchasePrice,
          sellingPrice: item.sellingPrice,
          brandId: item.brandId,
          qty: Number(item.qty / item.serialDetails.length), // Adjusted for each split item
          serialDetails: serial,
          _id: item._id,
        }))
      ),
    };
    const expandRowData =
      splitData && splitData.items.length > 0
        ? splitData.items.map((data) => {
            // const IMEINo =
            //   data.serialDetails && data.serialDetails.length > 0
            //     ? data.serialDetails[0].IMEI
            //     : "";
            // const serialDetailsArray =
            //   serialDetails.serialDetail && serialDetails.serialDetail
            //     ? serialDetails.serialDetail
            //     : "";
            const totalAmount =
              data.qty && data.purchasePrice
                ? Number(data.qty * data.purchasePrice)
                : data.totalAmount;
            return {
              modelName: data.modelName,
              gradeName: data.gradeName,
              qty: data.qty,
              purchasePrice:
                data.purchasePrice &&
                data.purchasePrice.toLocaleString("en-IN"),
              sellingPrice:
                data.sellingPrice && data.sellingPrice.toLocaleString("en-IN"),
              totalAmount: totalAmount && totalAmount.toLocaleString("en-IN"),
            };
          })
        : [];
    return (
      <Table
        columns={expandColumns}
        dataSource={expandRowData}
        pagination={false}
        rowClassName={"header-expand-purchase-invoice-column"}
      />
    );
  };

  //expand row end
  //data table
  // const hasSelected = selectedRowKeys.length > 0;

  const handleSearch = (event) => {
    // if (!event.target.value) return []; // Return empty if event.target.value is empty

    // const filteredRows = purchaseInvoiceDataTable.filter((item) => {
    //     // Search all object values (keys can be adjusted)
    //     return Object.values(item)
    //     .filter((value) => value !== undefined) // Ignore undefined values
    //     .some((value) =>
    //       String(value) // Convert the value to a string (handles both string and number values)
    //         .toLowerCase()
    //         .includes(event.target.value.toLowerCase())
    //     );
    //   })

    const filteredRows = purchaseInvoiceDataTable
      .filter((row) =>
        row.vendorNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates
    setSearch(event.target.value);
    setSalesInvoiceRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [deletePurchaseInvoiceModal, setDeletePurchaseInvoiceModal] =
    useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //deletPurchase api integrations
  const deletePurchaseInvoiceApi = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 6000);
    const itemListData = {
      organizationId: organizationId,
      piId: purchaseRemoveId ? purchaseRemoveId : "",
      // selectedRowKeys.length > 0 ? selectedRowKeys.map((data) => data) : "",
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    // dispatch(deletePurchaseInvoiceList(itemListData));
    api
      .post("/org/deletepurchaseinvoice", itemListData)
      .then((res) => {
        setTimeout(() => {
          dispatch(loadPurchaseInvoice(salesInvoiceList));
          setDeletePurchaseInvoiceModal(false);
          toast.info("Purchase Invoice deleted successfully");
        }, 1000);
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error);
        toast.error(errorMsg || "there is an issue while adding prefix");
        return Promise.reject(error);
      });
  };

  //import invoice
  const bulkActions = (
    <div>
      <div
        onClick={() =>
          history.push({
            pathname: "/purchase-invoice/import",
            state: {
              mode: "IMEI",
              prefixSettings: prefix_settings_list && prefix_settings_list,
            },
          })
        }
        className="hover:rounded-md hover:bg-[lightgray] hover:mr-[-3px] flex justify-between w-[270px] h-[45px] mt-[2px] pl-3 pr-2 pt-2 pb-12 cursor-pointer"
      >
        <div>
          <p className="flex text-[14px] font-semibold">
            <FileExcelOutlined className="mr-2" /> Bulk Import IMEI
          </p>
          <p className="mt-1 text-[12px]">
            Quickly add all your IMEI Details with Excel
          </p>
        </div>
        <BiRightArrowAlt size={24} />
      </div>
      <div
        onClick={() =>
          history.push({
            pathname: "/purchase-invoice/import",
            state: {
              mode: "Qty",
              prefixSettings: prefix_settings_list && prefix_settings_list,
            },
          })
        }
        className="border border-b-0 border-x-0 border-t-1 hover:bg-[lightgray] hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[55px] mt-[10px] mb-1 pl-3 pr-2 pt-2 pb-8 cursor-pointer"
      >
        <div>
          <p className="flex text-[14px] font-semibold">
            <FileExcelOutlined className="mr-2" /> Bulk Import Qty
          </p>
          <p className="mt-1 text-[12px]">
            Quickly add all your Qty details with Excel
          </p>
        </div>
        <BiRightArrowAlt size={24} />
      </div>
    </div>
  );

  const [isPrefixButtonDisabled, setIsPrefixButtonDisabled] = useState(false);

  //Prefix settings list
  const createPrefixSettings = () => {
    if (purchaseInvoiceData.prefix && purchaseInvoiceData.seqNo) {
      setIsPrefixButtonDisabled(true);
      setTimeout(() => {
        setIsPrefixButtonDisabled(false);
      }, 6000);
      const prefixList = {
        organizationId: organizationId,
        prefix: purchaseInvoiceData.prefix,
        sequenceNo: purchaseInvoiceData.seqNo,
        isEnable: invoiceShow === true ? true : false,
        isType: "isPurchase",
        createdBy: userId,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(purchasePrefixList));
          toast.success("Prefix updated successfully");
          setSettingsFieldModal(false);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setSettingsFieldModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed

  useEffect(() => {
    if (prefix_settings_list && prefix_settings_list.isEnable === true) {
      setPurchaseInvoiceData({
        ...purchaseInvoiceData,
        prefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
      });
      setInvoiceShow(true);
    } else {
      setPurchaseInvoiceData({
        ...purchaseInvoiceData,
        prefix: "",
        seqNo: "",
      });
      setInvoiceShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  //page load without saving

  useBeforeUnload({
    when: !isEmpty(purchaseInvoiceData.seqNo),
    message: "Are you sure you want to leave?",
  });

  //select days options start
  const options = [
    "Lifetime",
    "Today",
    "Yesterday",
    "This Week",
    "Last 7 days",
    "Last Week",
    "This Month",
    "Last 30 days",
    "Last Month",
    "Custom Range",
  ];
  const filterDataByDate = (filter) => {
    const purchaseInvoiceArray =
      purchase_invoice_list && purchase_invoice_list.length > 0
        ? purchase_invoice_list
        : [];
    const currentDate = new Date();

    let filteredData = purchaseInvoiceArray;

    if (filter === "Today") {
      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate.toDateString() === currentDate.toDateString();
      });
    } else if (filter === "Yesterday") {
      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        const yesterday = new Date(currentDate);
        yesterday.setDate(currentDate.getDate() - 1);
        return itemDate.toDateString() === yesterday.toDateString();
      });
    } else if (filter === "This Week") {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate >= startOfWeek && itemDate <= currentDate;
      });
    } else if (filter === "Last 7 days") {
      const last7Days = new Date(currentDate);
      last7Days.setDate(currentDate.getDate() - 7);
      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate >= last7Days && itemDate <= currentDate;
      });
    } else if (filter === "Last Week") {
      const startOfThisWeek = new Date(currentDate);
      startOfThisWeek.setDate(currentDate.getDate() - currentDate.getDay());
      const startOfLastWeek = new Date(startOfThisWeek);
      startOfLastWeek.setDate(startOfThisWeek.getDate() - 7);

      const endOfLastWeek = new Date(startOfThisWeek);
      endOfLastWeek.setDate(startOfThisWeek.getDate() - 1);

      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate >= startOfLastWeek && itemDate <= endOfLastWeek;
      });
    } else if (filter === "This Month") {
      const startOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate >= startOfMonth && itemDate <= currentDate;
      });
    } else if (filter === "Last Month") {
      const startOfLastMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      const endOfLastMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate >= startOfLastMonth && itemDate <= endOfLastMonth;
      });
    } else if (filter === "Last 30 days") {
      const last30Days = new Date(currentDate);
      last30Days.setDate(currentDate.getDate() - 30);
      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate >= last30Days && itemDate <= currentDate;
      });
    } else if (filter === "Custom Range") {
      if (!fromDate || !toDate) {
        console.error(
          "Custom Range requires both fromDate and toDate to be set"
        );
        return;
      }

      const from = new Date(fromDate);
      const to = new Date(toDate);

      if (isNaN(from.getTime()) || isNaN(to.getTime())) {
        console.error("Invalid date format for Custom Range");
        return;
      }

      filteredData = purchaseInvoiceArray.filter((item) => {
        const itemDate = new Date(item.createdAt);
        return itemDate >= from && itemDate <= to;
      });
    }

    setSalesInvoiceRows(
      filteredData.map((data, index) => ({
        _id: data._id,
        key: index + 1,
        amount: (
          <div className="flex">
            <p>{"₹ "}</p>
            <h1
              className="cursor-pointer ml-1 header-sales-invoice"
              onClick={() => purchaseInvoiceRoutes(data)}
            >
              {data.totalAmount.toLocaleString("en-IN")}
            </h1>
          </div>
        ),
        purchaseinvoiceNo: (
          <h1
            className="cursor-pointer header-sales-invoice"
            onClick={() => purchaseInvoiceRoutes(data)}
          >
            {data.purchaseinvoiceNo}
          </h1>
        ),
        purchaseinvoiceDate: (
          <h1
            className="cursor-pointer header-sales-invoice"
            onClick={() => purchaseInvoiceRoutes(data)}
          >
            {data.purchaseinvoiceDate
              ? moment(data.purchaseinvoiceDate).format("DD-MM-YYYY")
              : "--"}
          </h1>
        ),
        authorizedsignature: data.authorizedsignature,
        autoamountroundoff: data.autoamountroundoff,
        beforeautoroundoffamount: data.beforeautoroundoffamount,
        charge: data.charge,
        createdAt: data.createdAt
          ? moment(data.createdAt).format("DD-MM-YYYY")
          : "",
        createdBy: data.createdBy,
        financialyearId: data.financialyearId,
        isHistory: data.isHistory,
        partyId: data.partyId,
        items: data.items,
        notes: data.notes,
        organizationId: data.organizationId,

        subtotalamount: data.subtotalamount,
        taxableAmonut: data.taxableAmonut,
        termsandconditions: data.termsandconditions,
        totaltax: data.totaltax,
        totalAmount: data.totalAmount,
        totaltaxableValue: data.totaltaxableValue,
        transActionType: data.transActionType,
        type: data.type,
        updatedAt: data.updatedAt,
        vendorAddress: data.vendorAddress,
        vendorCity: data.vendorCity,
        vendorId: data.vendorId,
        productList: data.productList,
        products: data.items.length > 0 ? data.items.length : 0,
        vendorName: (
          <h1
            className="cursor-pointer header-sales-invoice"
            onClick={() => purchaseInvoiceRoutes(data)}
          >
            {data.vendorName}
          </h1>
        ),
        vendorNameValue: data.vendorName,
        // dueIn: (
        //   <h1
        //     className="cursor-pointer header-sales-invoice"
        //     onClick={() => purchaseInvoiceRoutes(data)}
        //   >
        //     <Badge
        //       className={
        //         data.purchaseinvoiceDate && validTill > 10
        //           ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
        //           : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
        //       }
        //     >
        //       {data.purchaseinvoiceDate && validTill > 1
        //         ? validTill + " Days"
        //         : validTill == 1
        //         ? validTill + " Day"
        //         : validTill <= 0
        //         ? "Expired"
        //         : ""}
        //     </Badge>
        //   </h1>
        // ),
        fullyPaid: (
          <Badge
            className={
              data.markasfullypaid === true
                ? "bg-[green] font-semibold header-sales-invoice rounded-md text-[white] text-[11px] pt-1 pb-1 pr-3 pl-3"
                : "bg-[#eb7367] font-semibold header-sales-invoice rounded-md text-[white] text-[11px] pt-1 pb-1 pr-3 pl-3"
            }
            onClick={() => purchaseInvoiceRoutes(data)}
          >
            {data.markasfullypaid === true ? "YES" : "NO"}
          </Badge>
        ),
        action: (
          <div
            onClick={() => {
              setDeletePurchaseInvoiceModal(true);
              setPurchaseRemoveId(data._id);
            }}
          >
            {/* <p className="flex text-[14px] font-semibold"> */}
            <DeleteOutlined className="cursor-pointer mr-2 text-[16px] font-semibold text-[#b31707]" />
            {/* Delete */}
            {/* </p> */}
          </div>
          // <Popover
          //   placement="bottomRight"
          //   trigger={"hover"}
          //   content={actionList}
          // >
          //   <div className="text-[#0c8ce9] cursor-pointer pr-1 pt-1">
          //     <MenuOutlined />
          //   </div>
          // </Popover>
        ),

        status: (
          <Badge
            className={
              data.status &&
              data.status.length > 0 &&
              data.status[0].statusName === "Active"
                ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
            }
            onClick={() => purchaseInvoiceRoutes(data)}
          >
            {data.status && data.status.length > 0 && data.status[0].statusName}
          </Badge>
        ),
      }))
    );
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 1000);
  };

  const handleOptionSelect = (event) => {
    const option = event.target.value;
    setSelectedOption(option);

    if (option === "Custom Range") {
      setIsModalOpen(true);
    } else {
      filterDataByDate(option);
    }
  };

  const handleApply = () => {
    if (fromDate && toDate) {
      setSelectedOption(`${fromDate} - ${toDate}`);
      setIsModalOpen(false);
      filterDataByDate("Custom Range");
      setSelectedOption("Custom Range");
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Purchase Invoices | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] mt-2 font-semibold"
              >
                Purchase Invoices
              </h1>
            </div>
            <div className="flex">
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your party specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",

                      fontFamily: "Poppins",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>

                {/* </a> */}
              </Dropdown>
              <Tooltip
                title="Easily add the Purchase Invoice settings"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => {
                    setSettingsFieldModal(true);
                    // dispatch(loadPrefixSettingsList(purchasePrefixList));
                  }}
                  className="border rounded-md ml-3 pt-2 pb-2 pl-3 pr-3 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        <div
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "add-purchase-home-main-large-device"
              : windowDimensions.height > 830 && windowDimensions.height < 1000
              ? "add-purchase-home-extra-main-large-device"
              : windowDimensions.height > 1000
              ? "add-purchase-home-main-infinite-large-device"
              : "add-purchase-invoices-home-main"
          }
        >
          <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
            <Row className="pl-5 pr-1 mt-5 mb-5">
              {purchaseHeaders.map((data) => {
                return (
                  <Col
                    md={8}
                    lg={8}
                    xl={8}
                    xxl={8}
                    sm={24}
                    xs={24}
                    key={data.key}
                    className={media == "sm" || media == "xs" ? "mb-2" : ""}
                  >
                    {loading ? (
                      <div className="pr-1">
                        <Skeleton.Input
                          style={{
                            marginRight: "5px",
                            minWidth: "165%",
                            height: "60px",
                          }}
                          active={true}
                          size={"large"}
                          // block={true}
                        ></Skeleton.Input>
                      </div>
                    ) : (
                      <div
                        className={
                          salesTab === data.label
                            ? "poppins mr-4 purchase-select-card purchase-card border rounded-md"
                            : data.key !== 3
                            ? "poppins mr-4 purchase-card border rounded-md"
                            : "poppins purchase-select-card purchase-card border rounded-md"
                        }
                        onClick={() => setSalesTab(data.label)}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            fontFamily: "Poppins",
                            color:
                              data.key == 1
                                ? "blue"
                                : data.key == 2
                                ? "#429559"
                                : "#AE1536",
                          }}
                        >
                          <p className={data.key !== 1 ? "mt-[2px]" : ""}>
                            {data.icon}
                          </p>
                          <h2 className={"ml-2 tracking-wide"}>{data.label}</h2>
                        </div>
                        <div className="ml-1 mt-1 flex">
                          <p className="font-semibold text-[18px]">₹ </p>
                          <h1
                            className="font-semibold tracking-wider ml-1 text-[18px]"
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {data.key == 1
                              ? (purchase_total_list &&
                                  purchase_total_list.totalSales &&
                                  purchase_total_list.totalSales.toLocaleString(
                                    "en-IN"
                                  )) ||
                                0
                              : data.key == 2
                              ? (total_paid_list &&
                                  total_paid_list.totalPaidAmount &&
                                  total_paid_list.totalPaidAmount.toLocaleString(
                                    "en-IN"
                                  )) ||
                                0
                              : (data.key == 3 &&
                                  total_unpaid_list &&
                                  total_unpaid_list.totalUnPaidAmount &&
                                  total_unpaid_list.totalUnPaidAmount.toLocaleString(
                                    "en-IN"
                                  )) ||
                                0}
                          </h1>
                        </div>
                      </div>
                    )}
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* purchase input section with bulk actions */}
          <Col
            md={24}
            sm={24}
            lg={24}
            xs={24}
            className="purchase-invoice-orders mt-1 mb-2"
          >
            <Row className="purchase-invoice-filters-main ml-4">
              <div className="purchase-invoice-filters">
                {loading ? (
                  <div
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    <Skeleton.Input
                      style={{
                        width: "100%",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <>
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      {/* {searchOpen ? ( */}
                      <div className="mr-2 filter-dropdown-filters">
                        <AutoComplete
                          style={{
                            marginRight: "10px",
                            fontSize: "11px",
                          }}
                          // onClick={() => setSearchOpen(false)}
                          className="w-[100%]"
                        >
                          <Input.Search
                            size="middle"
                            placeholder="Search Purchase"
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "11px",
                              minHeight: "35px",
                            }}
                            name="search"
                            value={search}
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      </div>
                      {/* ) : (
                        <div
                          onClick={() => setSearchOpen(true)}
                          className="filter-dropdown-search-filters border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                        >
                          <SearchOutlined size={16} />
                        </div>
                      )} */}
                    </Tooltip>
                  </>
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "30px",
                      width: "100%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    style={{
                      marginRight: "0.75rem",
                      // marginLeft: searchOpen ? "0.75rem" : "0rem",
                    }}
                    className="filter-dropdown-filters"
                  >
                    <div className="relative w-auto">
                      <select
                        className="filter-span w-[200px] h-[35px] p-2 border-1 rounded"
                        value={selectedOption}
                        onChange={handleOptionSelect}
                        style={{
                          fontFamily: "Poppins",
                        }}
                      >
                        {options.map((option) => (
                          <option key={option} value={option} className="mr-2">
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Modal */}
                    {isModalOpen && (
                      <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                          <h2
                            className="text-lg font-bold mb-4"
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            Select Date Range
                          </h2>
                          <div className="space-y-4">
                            <div className="flex flex-col">
                              <label
                                htmlFor="from-date"
                                className="expense-label text-sm mb-1"
                              >
                                From
                              </label>
                              <DatePicker
                                selected={fromDate}
                                className={
                                  media == "sm"
                                    ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                    : media == "xs"
                                    ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                    : media == "xl" ||
                                      media == "xxl" ||
                                      media == "lg"
                                    ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                    : "rounded-md border border-1 h-[40px] w-[95%] pl-2"
                                }
                                toggleCalendarOnIconClick={true}
                                icon={
                                  <BiCalendar
                                    //   size={30}

                                    className={
                                      media == "sm"
                                        ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                        : media == "xs"
                                        ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                        : media == "xl" ||
                                          media == "xxl" ||
                                          media == "lg"
                                        ? "top-[7px] text-[16px] right-[20px] text-[#9e9e9e]"
                                        : "top-[3px] text-[16px] right-[20px] text-[#9e9e9e]"
                                    }
                                  />
                                }
                                showIcon
                                onChange={(date) => {
                                  setFromDate(date);
                                }}
                                placeholderText="Select Date"
                              />
                              {/* <input
                                                          id="from-date"
                                                          type="date"
                                                          className="expense-label border p-2 rounded w-full"
                                                          onChange={(e) =>
                                                            setFromDate(e.target.value)
                                                          }
                                                        /> */}
                            </div>
                            <div className="flex flex-col">
                              <label
                                htmlFor="to-date"
                                className="text-sm mb-1 expense-label"
                                style={{
                                  fontFamily: "Poppins",
                                }}
                              >
                                To
                              </label>
                              <DatePicker
                                selected={toDate}
                                className={
                                  media == "sm"
                                    ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                    : media == "xs"
                                    ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                    : media == "xl" ||
                                      media == "xxl" ||
                                      media == "lg"
                                    ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                    : "rounded-md border border-1 h-[40px] w-[95%] pl-2"
                                }
                                toggleCalendarOnIconClick={true}
                                icon={
                                  <BiCalendar
                                    //   size={30}

                                    className={
                                      media == "sm"
                                        ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                        : media == "xs"
                                        ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                        : media == "xl" ||
                                          media == "xxl" ||
                                          media == "lg"
                                        ? "top-[7px] text-[16px] right-[20px] text-[#9e9e9e]"
                                        : "top-[3px] text-[16px] right-[20px] text-[#9e9e9e]"
                                    }
                                  />
                                }
                                showIcon
                                onChange={(date) => {
                                  setToDate(date);
                                }}
                                placeholderText="Select Date"
                              />
                            </div>
                          </div>
                          <div className="flex justify-center mt-6 space-x-2">
                            <button
                              className="px-2 py-2 expense-label rounded bg-gray-200 hover:bg-gray-300"
                              onClick={() => setIsModalOpen(false)}
                            >
                              Cancel
                            </button>
                            <button
                              className="py-2 px-2 expense-label rounded bg-[blue] text-white hover:bg-blue-300"
                              onClick={handleApply}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="flex purchase-invoice-actions">
                {loading ? (
                  <div className="pr-2">
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        width: "100%",
                        height: "35px",
                      }}
                      active={true}
                      size={"large"}
                      // block={true}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <Popover
                    placement="bottomRight"
                    trigger={"click"}
                    content={bulkActions}
                    className={
                      windowDimensions.width > 1600
                        ? "cursor-pointer"
                        : "cursor-pointer"
                    }
                  >
                    <Tooltip
                      title="Easily perform bulk actions on all your Parties"
                      placement="left"
                      rootClassName="text-[10px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                        }}
                        className={
                          "border h-[33px] rounded-sm flex justify-between pl-3 pr-3 pt-1 pb-1 cursor-pointer"
                        }
                      >
                        <div className="pr-1 pt-1">
                          <FileTextOutlined /> Bulk Action
                        </div>
                        <DownOutlined className="pt-1" />
                      </div>
                    </Tooltip>
                  </Popover>
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      paddingRight: "25px",
                      marginRight: "25px",
                      width: "90%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    onClick={() =>
                      history.push({
                        pathname: "/create-purchase-invoice",
                        state:
                          purchase_invoice_list &&
                          purchase_invoice_list.length > 0
                            ? purchase_invoice_list.length
                            : 1,
                      })
                    }
                    className="cursor-pointer ml-3 bg-[#6007ad] hover:bg-[#987ab3] p-4 text-[white] mr-4"
                  >
                    {/* <Link
                      to={{
                        pathname: "/create-purchase-invoice",
                        state:
                          purchase_invoice_list &&
                          purchase_invoice_list.length > 0
                            ? purchase_invoice_list.length
                            : 1,
                      }}
                    > */}
                    Create Purchase Invoice
                    {/* </Link> */}
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col span={24} className="pl-4 pr-4 pb-1">
            {/* {hasSelected ? (
              <Row className="flex justify-between mb-2">
                <Col
                  style={{
                    fontFamily: "Poppins",
                    color: "#ffffff",
                    background: "#4096ff",
                    borderRadius: "10px",
                    padding: "5px 10px",
                  }}
                  className="mb-1"
                  span={4}
                >
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </Col>
                {selectedRowKeys.length > 0 ? (
                  <Col className="hidden">
                    <Tooltip
                      title="Delete Purchase Invoice"
                      placement="topLeft"
                    >
                      <div
                        onClick={() => setDeletePurchaseInvoiceModal(true)}
                        className="cursor-pointer border border-1 p-[8px] rounded-md"
                      >
                        <DeleteOutlined className="text-[#eb4e50] text-[16px]" />
                      </div>
                    </Tooltip>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            ) : (
              ""
            )} */}
          </Col>
          <Col
            span={24}
            className={
              media === "xxl"
                ? "pt-6 pr-4 pl-4 purchase-invoice-orders"
                : "pt-5 pr-4 pl-4 purchase-invoice-orders"
            }
          >
            <Table
              style={{
                overflow: "hidden",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                salesInvoiceRows &&
                salesInvoiceRows.length > 0 &&
                !isEmpty(salesInvoiceRows[0].vendorNameValue)
                  ? salesInvoiceRows
                  : []
              }
              rowClassName={"text-[12px] p-0"}
              expandable={{
                expandedRowRender: expandedRowRender,
                defaultExpandAllRows: false,
                expandedRowKeys: expandedRowKeys,
                onExpand: onTableRowExpand,
                // expandIconColumnIndex: 5,
              }}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              loading={tableLoading ? true : false}
              showSorterTooltip={"sorter-icon"}
              rowKey={(record) => record._id}
              // rowSelection={{
              //   selectedRowKeys,
              //   onSelectAll: (selectedRowKeys, selectedRows, row) => {
              //     const newSelecteds = selectedRows.map((n) => n._id);
              //     setSelectedRowKeys(newSelecteds);
              //   },
              //   onSelect: (selectedRowKey, selectedRows, row) => {
              //     const selectedIndex = selectedRowKeys.indexOf(
              //       selectedRowKey._id
              //     );
              //     let newSelecteds = [];

              //     if (selectedIndex === -1) {
              //       newSelecteds = newSelecteds.concat(
              //         selectedRowKeys,
              //         selectedRowKey._id
              //       );
              //     } else if (selectedIndex === 0) {
              //       newSelecteds = newSelecteds.concat(
              //         selectedRowKeys.slice(1)
              //       );
              //     } else if (selectedIndex === selectedRowKeys.length - 1) {
              //       newSelecteds = newSelecteds.concat(
              //         selectedRowKeys.slice(0, -1)
              //       );
              //     } else if (selectedIndex > 0) {
              //       newSelecteds = newSelecteds.concat(
              //         selectedRowKeys.slice(0, selectedIndex),
              //         selectedRowKeys.slice(selectedIndex + 1)
              //       );
              //     }
              //     setSelectedRowKeys(newSelecteds);
              //   },
              // }}
              scroll={{
                y:
                  // salesInvoiceRows.length <= 3
                  //   ? 150
                  //   :
                  windowDimensions.height > 500 ? "100%" : "",
                // y:
                //   windowDimensions.height > 800 && windowDimensions.height < 900
                //     ? 600
                //     : windowDimensions.height > 900 &&
                //       windowDimensions.height < 1000
                //     ? 1000
                //     : windowDimensions.height > 1000
                //     ? 1100
                //     : 250,
                x: 765,
              }}
            />
          </Col>
        </div>
        {/* Custom fields modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Purchase Invoice Settings"
          onOk={createPrefixSettings}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isPrefixButtonDisabled ? true : false,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Purchase Invoice Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="mb-1 purchase-label">
                    Prefix
                  </Typography>

                  <Input
                    name="prefix"
                    value={purchaseInvoiceData.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(purchaseInvoiceData.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography className="mb-1 purchase-label">
                    Sequence Number
                  </Typography>

                  <Input
                    name="seqNo"
                    value={purchaseInvoiceData.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(purchaseInvoiceData.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="mb-1 purchase-label">
                    Purchase Invoice Number:{" "}
                    {purchaseInvoiceData.prefix
                      ? purchaseInvoiceData.prefix +
                        "" +
                        purchaseInvoiceData.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
      </Row>
      {/* Delete purchase modal */}

      <Modal
        open={deletePurchaseInvoiceModal}
        onOk={() => {
          deletePurchaseInvoiceApi();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete ${
          ""
          // selectedRowKeys.length > 0 ? selectedRowKeys.length : ""
        } PI`}
        cancelText={"Cancel"}
        okType="danger"
        onCancel={() => setDeletePurchaseInvoiceModal(false)}
        height={100}
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-3">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[16px] font-bold">
            Are you sure you want to delete these Purchase Invoice?
          </h1>
          <p className="text-center text-[14px] mt-2">
            Once deleted you will not be able to restore these purchase invoice.
          </p>
        </div>
      </Modal>
      <Prompt
        when={!isEmpty(purchaseInvoiceData.seqNo)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

PurchaseInvoice.propTypes = {
  location: PropTypes.any,
};

export default PurchaseInvoice;
